class AccountPage {
    private infoEditBtn: HTMLElement | null;
    private form: HTMLElement | null;
    private info: HTMLElement | null;

    constructor() {
        this.infoEditBtn = document.querySelector('[name="primaryTextButton"]');
        this.form = document.getElementById('account__form');
        this.info = document.getElementById('account__info');
        this.initialize();
    }

    private initialize(): void {
        if (this.infoEditBtn) {
            this.infoEditBtn.addEventListener('click', () => this.toggleFormVisibility());
        }
    }

    private toggleFormVisibility(): void {
        this.form?.classList.toggle('account__form--active');
        this.info?.classList.toggle('account__info--inactive');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    new AccountPage();
});